import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { REVIEWS } from "../../constant/Testimonials";
import Eyebrow from "../common/Eyebrow";

const CustomerStory = () => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedTestimonial((prevIndex) => {
        return (prevIndex + 1) % REVIEWS.length;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setSelectedTestimonial(index);
  };

  const currentReview = REVIEWS[selectedTestimonial];

  return (
    <section className="bg-slate-50 px-6 py-20">
      <div className="mx-auto max-w-4xl text-center">
        <Eyebrow>Customer stories</Eyebrow>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-[var(--website-primary-color)] md:text-4xl">What Our Customers Say</h2>
        <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-slate-600">
          Hear from the businesses who trust us to deliver exceptional solutions
          and results.
        </p>

        <div className="mx-auto mt-10 flex min-h-[380px] max-w-3xl flex-col items-center justify-center overflow-hidden rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-[min-height] duration-300 ease-in-out md:min-h-[320px] md:p-10">
          <AnimatePresence mode="wait">
            <motion.div
              key={selectedTestimonial}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.35, ease: "easeInOut" }}
              className="flex flex-col items-center"
            >
              <img
                src={currentReview.avatar}
                alt={currentReview.name}
                className="mb-5 h-24 w-24 rounded-full border-4 border-slate-100 object-cover transition duration-300 hover:scale-110"
                loading="lazy"
              />

              <h3 className="text-xl font-semibold text-[var(--website-primary-color)]">
                {currentReview.name}
              </h3>
              <p className="mt-1 text-sm text-slate-500">{currentReview.role}</p>

              <p className="mt-8 text-lg leading-relaxed text-slate-700">“{currentReview.review}”</p>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-8 flex justify-center space-x-2">
          {REVIEWS.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              aria-label={`Show testimonial ${index + 1}`}
              className={`h-2.5 w-2.5 rounded-full transition-all duration-300 ${
                selectedTestimonial === index
                  ? "bg-[var(--website-primary-color)]"
                  : "bg-gray-400 hover:bg-[var(--website-primary-color)]"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerStory;
